import { sortBy } from 'lodash-es'

// JS iterates integer-like keys in ascending order, which would list attachments by id; a prefixed key keeps
// insertion order, so the uploader shows them in selection order (attachments saved before positions existed first)
export const existingAttachmentKey = (id) => `attachment-${id}`

// Selection order; attachments saved before positions existed have none and come first, by id
export const sortAttachments = (attachments) =>
  sortBy(attachments, [(attachment) => attachment.position ?? -Infinity, 'id'])

export const transformAttachmentsForSandboxUploader = (attachments) => {
  const ordered = sortAttachments(Object.values(attachments))

  return Object.fromEntries(
    ordered.map((attachment) => [
      existingAttachmentKey(attachment.id),
      {
        file: {
          name: attachment.original_filename,
          type: attachment.type,
          size: attachment.bytes,
        },
        metadata: {
          urls: {
            pdf: attachment.url,
          },
        },
      },
    ])
  )
}
